import React, { type ReactNode } from "react";
import { Text, type TextProps, type PlacementWithLogical, Tooltip as ChakraTooltip } from "@chakra-ui/react";

export type TooltipProps = {
  /**
   * Tooltip message.
   */
  message: string;

  /**
   * The placement of the tooltip.
   *
   * @default "auto"
   */
  placement?: PlacementWithLogical;

  /**
   * Element to show tooltip around.
   */
  children: ReactNode;

  /**
   * Additional styles for the text rendered in the tooltip.
   */
  textProps?: TextProps;
};

export function Tooltip({ message, children, placement = "auto", textProps }: TooltipProps) {
  return (
    <ChakraTooltip
      label={
        <Text as="span" color="white" fontWeight="semibold" wordBreak="break-word">
          {message}
        </Text>
      }
      placement={placement}
    >
      <Text as="span" textDecoration="underline" textDecorationStyle="dotted" textUnderlineOffset="2px" {...textProps}>
        {children}
      </Text>
    </ChakraTooltip>
  );
}
